export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: 'Deseja remover a especialização <strong>' + this.currentEntity.area + '</strong>?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/index/resources/computed.js